const bidMixin = {
  beforeMount () {
    this.scriptLoader('https://s3.ap-northeast-2.amazonaws.com/event.js.manage.s3/js/lottecard_get_bid.js?v=' + new Date().getTime()).then((result) => {
      this.bid = window.getUniqueId()
    })
  },
  data () {
    return {
      bid: null
    }
  },
  methods: {
    scriptLoader (url) {
      return new Promise((resolve, reject) => {
        const existing = document.querySelector('script#bid')
        if (existing) existing.parentNode.removeChild(existing)
        const script = document.createElement('script')
        script.onload = () => {
          resolve()
        }
        script.onerror = e => {
          reject(e)
        }
        script.id = 'bid'
        script.async = true
        script.src = url
        document.head.appendChild(script)
      })
    }
  }
}
export default bidMixin
